import styled from "styled-components";
import CommonCell from "./CommonCell";
import { useMemo } from "react";

const ChatBackground = ({ line, cellHeight }) => {
  const backgroundCells = useMemo(() => {
    let arr = [];
    for (let i = 0; i < 5 * line; i++) {
      arr.push(
        <CommonCell
          styles={{ width: `20%`, height: `${cellHeight}px` }}
          key={`${i}chatCellKey`}
        />
      );
    }
    return arr;
  }, [line, cellHeight]);
  return <Wrap>{backgroundCells} </Wrap>;
};

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  /* z-index: 0; */
  left: 0;
  top: 0;
`;

export default ChatBackground;
